module.exports = __webpack_public_path__ + "media/patterndecryption.b4782c51.mp4";